// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".template-page .tips-box[data-v-334881d6] {\n  margin-left: 50px;\n  color: #7F7F7F;\n}\n.template-page .tips-box .tips-label[data-v-334881d6] {\n  color: #333;\n  font-weight: 500;\n}\n.template-page .tips-box .el-icon-warning-outline[data-v-334881d6] {\n  color: var(--prev-color-primary);\n  font-size: 20px;\n  margin: 0 5px 0 10px;\n}", ""]);
// Exports
module.exports = exports;
